
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useAuth } from '@/context/AuthContext';
import { useBackNavigation } from '@/hooks/useBackNavigation';
import { Button } from '@/components/ui/button';
import PageTitle from './header/PageTitle';
import UserMenu from './auth/UserMenu';
import LanguageSelector from './LanguageSelector';
import AccessibilityButton from './AccessibilityButton';

const Header = () => {
  const { dir } = useLanguage();
  const { user } = useAuth();
  const { shouldShowBackButton, handleBack, getBackIcon, getBackText } = useBackNavigation();
  
  return (
    <header className="sticky top-0 z-50 bg-gray-50 shadow-sm">
      <div className="agam-color-bar"></div>
      
      {/* Top Navigation Bar */}
      <div className="museum-container">
        <div className="flex items-center h-14">
          {/* Left side - Back button (when applicable) */}
          <div className="flex items-center">
            {shouldShowBackButton && (
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={handleBack}
                className="flex items-center gap-1"
              >
                {React.createElement(getBackIcon(), { className: "h-4 w-4" })}
                {getBackText()}
              </Button>
            )}
          </div>
          
          {/* Center - Page Title */}
          <div className="flex-1 flex justify-center">
            <PageTitle />
          </div>
          
          {/* Right side controls - Right side in LTR, Left side in RTL */}
          <div className={`flex items-center space-x-2 ${dir === 'rtl' ? 'space-x-reverse' : ''}`}>
            {/* Accessibility Button */}
            <AccessibilityButton />
            
            {/* Language Selector */}
            <LanguageSelector />
            
            {/* Show UserMenu if user is authenticated */}
            {user && <UserMenu />}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
